import IconTextProperty from '@/features/Commons/Label/IconTextProperty';
import { type FeedbackSentiment, sentimentMap } from '@/types/feedbackConst';

interface Props {
  type: FeedbackSentiment;
  size?: 's' | 'm' | 'l';
}

const SentimentBadge = ({ type, size = 'm' }: Props) => {
  return (
    <IconTextProperty
      icon={sentimentMap[type]?.icon || sentimentMap[2]?.icon}
      value={sentimentMap[type]?.value || sentimentMap[2]?.value}
      size={size}
    />
  );
};

export default SentimentBadge;
